
var filter,
    $filterTags,
    $filterReset,
    $filterResetProgram,
    $filterCheck,
    $filterCategories,
    $filterInputs,
    $showResults,
    $filterConfirmed,
    $filterCancelled,
    $filterSearch,
    $filterTagCount;

$(document).ready(function($) {
    $filterCategories = $('.js-add-filter');
    $showResults = $('.js-apply-filters');
    $filterInputs = $('.js-filter-input');
    $filterTags = $('.js-filter-tags');
    $filterReset = $('.js-filter-reset');
    $filterResetProgram = $('.js-filter-reset-program');
    $filterConfirmed = $('.js-filter-confirmed');
    $filterCancelled = $('.js-filter-cancelled');
    $filterSearch = $('.js-filter-search-input');
    $filterTagCount = $('.js-tag-count');
    

    $showResults.on('click', function(e) {
        e.preventDefault();
        filter.rebuildUrl();
        closeMenu();
    });

    $filterInputs.on('click', function(e) {
        filter.filterUpdateTags($(this));
    });

    // $filterSearch.on('keyup', function() {
    //   if ( $filterSearch.val().length > 1 ) {
    //     filter ? filter.reset(true) : undefined;
    //   }
    // });

    $filterConfirmed.on('click', function () {
        let $quickFilter = $('.js-quick-tag-check-confirmed-events');

        let $checkedBoxes = $(".js-filter-input:checked, .js-filter-confirmed:checked");
        filter.updateTagCounter($checkedBoxes.length);

        if ($(this).is(':checked')) {
            filter.showConfirmedOnly = true;
            $quickFilter.addClass('is-active');
            return;
        }

        $quickFilter.removeClass('is-active');
        filter.showConfirmedOnly = false
    });

    $filterCancelled.on('click', function () {
        if ($(this).is(':checked')) {
            filter.hideCancelled = true;
            return;
        }

        filter.hideCancelled = false
    });

    $filterReset.on('click', function(e) {
        e.preventDefault();
        filter.reset();
    });

    $('body').on('click', '.js-filter-tag', function(e){
        e.preventDefault();
        filter.removeFilter($(this));
        filter.rebuildUrl();
        filter.updateTagCounter(0);
    });


    $('body').on('click', '.js-quick-tag', function(e){
        e.preventDefault();

        if ($(this).hasClass('is-active')) {
            // Disable Tag
            filter.disableQuickTag($(this));
        } else {
            // Enable Tag
            filter.enableQuickTag($(this));
        }

        filter.rebuildUrl();

        let $checkedBoxes = $(".js-filter-input:checked, .js-filter-confirmed:checked");
        filter.updateTagCounter($checkedBoxes.length);
    });
});


$(window).load(function() {
    $filterCheck = $('.js-filter');

    if ($filterCheck.length > 0 ) {
        // Setup filter
        filter = new Filter();
        filter.init();
    }
});

function Filter () {
    let genres;
    let kenmerken;
    let locations;
    let months;

    let hideCancelled = false;
    let showConfirmedOnly = false;

    this.disableQuickTag = function($this) {
        let slug = $this.attr('data-slug');
        let $inputTarget = $('#' + slug);
        let $sameTag = $('.js-quick-tag-' + slug);

        $sameTag.removeClass('is-active');
        $inputTarget.prop( "checked", false );
    }

    this.enableQuickTag = function($this) {
        let slug = $this.attr('data-slug');
        let $inputTarget = $('#' + slug);
        let $sameTag = $('.js-quick-tag-' + slug);

        $sameTag.addClass('is-active');
        $inputTarget.prop( "checked", true );
        $filterResetProgram.addClass('is-visible');
    }

    this.init = function() {
        this.filterUpdateTags();
    }

    this.rebuildUrl = function() {
        this.getValues();
        this.updateUrl();
        this.updateFilter();
    }

    this.removeFilter = function($this) {
        let id = $this.attr('data-target');
        let $target = $("#" + id)
        let $sameTag = $(".js-tag-" + id)

        $target.prop( "checked", false );
        $sameTag.remove();
    }

    this.reset = function(leaveText) {
        $('.js-filter-tag').each(function() {
            filter.removeFilter($(this));
        });

        $('.js-quick-tag').each(function() {
            filter.disableQuickTag($(this));
        });

        if ( !leaveText ) {
          $filterSearch.val('');
        }
        $filterTags.removeClass('is-searching');
        filter.rebuildUrl();

        this.updateTagCounter(0);
    }

    this.filterUpdateTags = function($this) {
        this.emptyTags();

        if (typeof $this !== "undefined") {
            let thisId = $this.attr('id');
            let $thisTarget = $('.js-quick-tag-' + thisId);
            $thisTarget.removeClass('is-active');
        }

        // Get checked inputs
        let $checkedBoxes = $(".js-filter-input:checked, .js-filter-confirmed:checked");

        $checkedBoxes.each(function() {
            let value = $(this).val();
            let name = $(this).attr('data-name');
            let id = $(this).attr('id');

            let $quickTag = $('.js-quick-tag-' + id);
            if ($quickTag.length > 0) {
                $quickTag.addClass('is-active');
            } else {
                $filterTags.append("<button class='c-tags__tag js-filter-tag js-tag-"+id+"' data-target='"+id+"' data-slug='"+value+"'>"+name+"</button>");
            }
        });

        this.updateTagCounter($checkedBoxes.length);
    }

    this.updateTagCounter = function (amount) {
        $filterTagCount.html(amount);

        if (amount === 0) {
            $filterTagCount.parent().removeClass('show-count');
            $filterReset.removeClass('is-visible');
        } else {
            $filterTagCount.parent().addClass('show-count');
            $filterReset.addClass('is-visible');
        }
    }

    this.emptyTags = function() {
        $('.js-filter-tag').remove();
        this.updateTagCounter(0);
    }

    this.updateFilter = function() {
        let data = {
            'event-genre' : this.genres,
            'event-kenmerk' : this.kenmerken,
            'event-location' : this.locations,
            'month' : this.months,
            'hide-cancelled': this.hideCancelled,
            'confirmed-only' : this.showConfirmedOnly,
        }

        showFilterTaxonomyResults(data);
    }

    this.showResults = function() {
        this.rebuildUrl();
    }

    this.getValues = function() {
        this.genres = this.getValuesFromName('event-genre');
        this.kenmerken = this.getValuesFromName('event-kenmerk');
        this.locations = this.getValuesFromName('event-location');
        this.months = this.getValuesFromName('month');

        this.hideCancelled = this.getCheckboxBoolean('#check-canceled-events');
        this.showConfirmedOnly = this.getCheckboxBoolean('#check-confirmed-events');
    }

    this.getCheckboxBoolean = function(id) {
        return $(id).is(':checked');
    }

    this.getValuesFromName = function(name) {

        var $checkedBoxes = $(".js-filter-"+name+":checked");

        var values = [];
        $checkedBoxes.each(function(){
            values.push($(this).val());
        });

        return values.join();
    }


    this.getUrlParams = function() {
        let parameters = {}

        if( this.genres !== "") {    parameters['genre'] = encodeURIComponent(this.genres);}
        if( this.kenmerken !== "") { parameters['kenmerk'] = encodeURIComponent(this.kenmerken);}
        if( this.locations !== "") { parameters['location'] = encodeURIComponent(this.locations);}
        if( this.months !== "") {    parameters['month'] = encodeURIComponent(this.months);}


        if( this.hideCancelled === true) {       parameters['hide-cancelled'] = true;}
        if( this.showConfirmedOnly === true) {   parameters['confirmed-only'] = true;}

        var queryString = $.param(parameters);

        if (queryString) {
            return queryString;
        }

        return false;
    }

    this.updateUrl = function() {
        let parameters = this.getUrlParams();
        if (parameters) {
            history.pushState(null, null, this.baseUrl() + '?' + parameters);
        } else {
            history.pushState(null, null, this.baseUrl() );
        }
    }

    this.baseUrl = function() {
        return window.location.protocol + "//" + window.location.host + window.location.pathname;
    }
}
